var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBunkBed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M4.63 4.656v19.688M23.53 7.938v16.406M19.12 7.938v16.406M19.12 22.375H4.63M19.12 19.75H4.63M19.12 10.563H4.63M19.12 13.188H4.63M19.12 10.563h4.41M19.12 14.5h4.41M19.12 18.438h4.41M19.12 22.375h4.41"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M8.41 10.563c-.696 0-1.26-.588-1.26-1.313s.564-1.312 1.26-1.312h1.26c.695 0 1.26.587 1.26 1.312s-.565 1.313-1.26 1.313zM8.41 19.75c-.696 0-1.26-.588-1.26-1.312s.564-1.313 1.26-1.313h1.26c.695 0 1.26.588 1.26 1.313 0 .724-.565 1.312-1.26 1.312z",
  clipRule: "evenodd"
})));
export default SvgBunkBed;